import { Modal, Icon } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';
import { connect, MapDispatchToProps } from 'react-redux';

import { CLOSE_MODAL } from '@src/containers/Modals/Modals.actions';

import messages from './Deferred.messages';
import styles from './DeferredModal.module.css';

interface DeferredModalProps {
    isOpen: boolean;
    closeModal: () => void;
}

interface DispatchProps {
    closeModal: () => void;
}

const mapDispatchToProps: MapDispatchToProps<DispatchProps, unknown> = (
    dispatch
) => ({
    closeModal: () => dispatch({ type: CLOSE_MODAL })
});

const DeferredModal: React.FC<DeferredModalProps> = ({
    isOpen,
    closeModal
}) => {
    return (
        <Modal
            className={styles.deferredModalContainer}
            onClose={closeModal}
            isOpen={isOpen}
            closeIcon
            size="small">
            <div className={styles.titleContainer}>
                <Icon
                    data-testid="warning-icon"
                    icon="alertTriangle"
                    className={styles.warningAlertTriangle}
                />
                <FormattedMessage {...messages.title} tagName="h2" />
            </div>
        </Modal>
    );
};

export default connect(null, mapDispatchToProps)(DeferredModal);
